// StudentSearch.js
import React, { useState, useEffect } from "react";
import { useEleveWitouthGroup} from "../../../hooks/fetch_api_hook/useEleveWithoutGroup";
import { useClasseContext } from "../../../context/ClasseContext";
import Loading from "../../general/Loading";
import { useDeleteEleveFromGroup } from "../../../hooks/delete_api_hook/useDeleteEleveFromGroup";
import { useParams } from "react-router-dom";
import useConfirm from "../../../hooks/ui/useConfirm";
const DeleteEleveFromGroup = ({ eleve, setMessagePost, setListEleves , handleReload }) => {
    // Hook pour supprimer l'élève.
    const {deleteEleveFromGroup, isLoading, error } = useDeleteEleveFromGroup();
    const { confirm, ConfirmDialog } = useConfirm();

const {idclasse} = useParams();

 


  
  const handleRemoveEleveFromGroup = async (event,eleve) => {
  
    event.stopPropagation();
     // Utiliser une chaîne de template pour une meilleure lisibilité et éviter les erreurs de formatage
  const confirmDelete = await confirm({
      title: "Supprimer cet élève du groupe ?",
      message: `Élève : ${eleve.nom} ${eleve.prenom}`,
      confirmLabel: "Supprimer",
      variant: "danger",
    });
    if (confirmDelete) {
      // Si l'utilisateur confirme, procéder à la suppression
      await deleteEleveFromGroup(eleve.id , idclasse);
      setMessagePost("Élève correctement supprimé :"+ eleve.nom + " " + eleve.prenom)
      setListEleves(prevListEleve => prevListEleve.filter(e => e.id !== eleve.id));
      handleReload();
    } 
    else {
      // Si l'utilisateur annule, ne rien faire
   
    }
  };

  

  return (
    <>
     <button    className="button bg-orange-500 rounded-xl text-white text-xs p-2  border  hover:bg-orange-600" onClick={(event)=> handleRemoveEleveFromGroup(event,eleve)}> Supprimer l'élève du groupe </button>
     {ConfirmDialog}
    </>
  );
};

export default DeleteEleveFromGroup;